/* eslint @typescript-eslint/camelcase: 0 */

import Vue from "vue";
import VueRouter, {RouteConfig} from "vue-router";
import {Component, Route} from "vue-router/types/router";
import {Meta} from "@/router/Meta";
import {cloneDeep} from "lodash";

// 基本
import SignIn from "@/components/pages/SignIn.vue";
import Home from "@/components/pages/Home.vue";
import Blank from "@/components/pages/Blank.vue";
import ErrorPage from "@/components/pages/Error.vue";

// その他
import admin from "@/router/routes/admin";
import contract from "@/router/routes/contract";
import dictionary from "@/router/routes/dictionary";
import easy from "@/router/routes/easy";
import implementation from "@/router/routes/implementation";
import profile from "@/router/routes/profile";

Vue.use(VueRouter);

type RoutePropsFunction = (route: Route) => Record<string, any>;

interface HcmChildRouteConfig extends Omit<RouteConfig, 'component' | 'components' | 'props'> {
  name: string;
  component: Component;
  props?: boolean | Record<string, any> | RoutePropsFunction;
}

/**
 * このアプリケーションで使用する RouteConfig
 */
export interface HcmRouteConfig extends Omit<RouteConfig, 'component' | 'components' | 'props' | 'children'> {
  name: string;
  component?: Component;
  props?: boolean | Record<string, any> | RoutePropsFunction;
  meta: Meta;
  children?: HcmChildRouteConfig[];
}

const routes: HcmRouteConfig[] = [
  /********************************************************************************************************************
   * 基本
   ********************************************************************************************************************/

  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      label: 'ホーム',
    }
  }, {
    path: '/error',
    name: 'Error',
    component: ErrorPage,
    meta: {
      label: 'エラー',
    }
  }, {
    path: '/signin',
    name: 'SignIn',
    component: SignIn,
    meta: {
      label: 'ログイン',
    }
  }, {
    path: '/',
    name: 'Blank',
    component: Blank,
    props: true,
    meta: {
      label: '',
    }
  },

  ...admin,
  ...contract,
  ...dictionary,
  ...easy,
  ...implementation,
  ...profile
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
});

/**
 * ルートを再利用します
 *
 * @param name 既存のルート名
 * @param newRoute 新規のルート情報
 */
export function recycleRoute(name: string, newRoute: {name: string; path: string; meta?: Partial<Meta>}): HcmRouteConfig {
  const org = routes.find(r => r.name === name);
  if(!org) {
    throw new Error(`${name} not found.`);
  }
  return {
    ...org,
    path: newRoute.path,
    name: newRoute.name,
    meta: {
      ...cloneDeep(org.meta),
      ...newRoute.meta
    },
    children: org.children?.map(child => {
      let newChildName = child.name;
      if(newChildName.startsWith(org.name)) {
        newChildName = newChildName.substr(org.name.length)
      }
      return {
        path: child.path,
        name: newRoute.name + newChildName,
        component: child.component
      };
    })
  };
}

export default router;
